exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pension-collaboration-wrapper {\n  height: 100%;\n}\n\n.pension-collaboration-wrapper .navigation-content-wrap {\n  display: flex;\n}\n\n", ""]);

// exports
